export default __webpack_public_path__ + "static/media/older.4dc4c531.svg";